import { FLUSH, REHYDRATE } from 'redux-persist'
import { List, Map, Record } from 'immutable'
// @ts-ignore
import { handleActions } from 'redux-actions'
import * as actions from './actions'

import { CATEGORY_TAG_DEFAULT } from 'store/records/activity'
// eslint-disable-next-line no-unused-vars
import { ICategoriesTagsWithSumOfActivities } from './interface'

export const Generator = Record(
  {
    libraryLevels: List(),
    categoriesTagsWithActivities: List(),
    minimumPercentage: 0,
    numberOfDays: 0,
  },
  'generator'
)

const handleFlush = () => {
  return new Generator()
}

const handleRehydrate = () => {
  return new Generator()
}

const handleFetchLibrariesLevelsSuccess = (state: any, { payload: { data } }: any) => {
  return state.set('libraryLevels', List(data))
}

const handleFetchCategoriesTagsForCurrentLibraryLevelSuccess = (
  state: any,
  { payload: { data } }: ICategoriesTagsWithSumOfActivities
) => {
  return state
    .set(
      'categoriesTagsWithActivities',
      List(
        data.categoriesTags.map(categoryTag => {
          return Map({
            id: categoryTag.id,
            name: categoryTag.name,
            proTrackLibraryLevelActivities: List(
              categoryTag.proTrackLibraryLevelActivities.map(activity =>
                Map({
                  ...activity,
                  categoryTag: activity.categoryTag ? activity.categoryTag : CATEGORY_TAG_DEFAULT,
                })
              )
            ),
          })
        })
      )
    )
    .set('minimumPercentage', data.minimumPercentage)
    .set('numberOfDays', data.numberOfDays)
}

const handleClearCategoriesTagsWithActivities = (state: any) => {
  return state.set('categoriesTagsWithActivities', List())
}

export default handleActions(
  {
    [REHYDRATE]: handleRehydrate,
    [FLUSH]: handleFlush,
    // @ts-ignore
    [actions.fetchLibrariesLevels.success]: handleFetchLibrariesLevelsSuccess,
    // @ts-ignore
    [actions.fetchCategoriesTagsForCurrentLibraryLevel.success]: handleFetchCategoriesTagsForCurrentLibraryLevelSuccess,
    [actions.clearCategoriesTagsWithActivities.toString()]: handleClearCategoriesTagsWithActivities,
  },
  new Generator()
)
